// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Mixins, Palette, Shadows, Theme, Transitions, ZIndex } from '@mui/material';
import { Typography } from '@mui/material/styles/createTypography';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
// ----------------------------------------------------------------------
const variantTypes = {
  success: "success",
  failed: "failed",
  pending: "pending"
}
interface IStyledProps{
  theme: {
    mixins: Mixins;
    palette: Palette;
    shadows: Shadows;
    transitions: Transitions;
    typography: Typography;
    zIndex: ZIndex;
    unstable_strictMode?: boolean;
  }
}

export const StyledToast = styled(Snackbar)(({ theme }: IStyledProps) => {
  return {

  };
});
